import "./exports/index";
import "react-loading-skeleton/dist/skeleton.css";
import "../scss/style.scss";
import "./common/features/cookieConsent/ConsentManager";
import { initScrollAnimations } from "./common/animation/scrollAnimations";
import "./app/i18n";
import { listen } from "quicklink";
import { store } from "./app/store";
import { hydrateComponents } from "./app/hydrate";
import { syncLanguageToUrl } from "./common/helpers/syncLanguageToUrl";

// Header Logic
import { initDefaultTopBarSwiper } from "./parts/header/topBarDefault";
import { initAuraTopBarSwiper } from "./parts/header/topBarAura";
import { initAuraStickyHeader } from "./parts/header/stickyHeaderAura";
import { initStickyHeaderNova } from "./parts/header/stickyHeaderNova";
import { initMobileMenuOffcanvas } from "./parts/header/mobileMenu";

// AURA DESIGN SYSTEM
import { initArchiveMasonry } from "./partials/PageContent/aura/archiveMasonry";
import { initHeroSlider } from "./partials/PageContent/aura/heroSlider";
import { initHeroBento } from "./partials/PageContent/aura/heroBento";
import { initCtaSlider } from "./partials/PageContent/aura/ctaSlider";
import { initCtaImageParallax } from "./partials/PageContent/aura/ctaImage";
import { initCategoriesSlider } from "./partials/PageContent/aura/categoriesSlider";
import { initArchiveShowcaseVideos } from "./partials/PageContent/aura/archiveShowcase";
import { initArticleWSlider } from "./partials/PageContent/aura/articleWSlider";
import { initServicesDeck } from "./partials/PageContent/aura/servicesDeck";

// NOVA DESIGN SYSTEM
import { initNovaHomeCarousel } from "./partials/PageContent/nova/homeCarousel";

// APEX DESIGN SYSTEM
import { initApexAutoSlider } from "./partials/PageContent/apex/autoSlider";

// Post Components
import { initVideoFacades } from "./partials/PostContent/aura/video";
import { initGalleries } from "./partials/PostContent/aura/gallery";
import { initAccordions } from "./partials/PostContent/aura/accordion";

const initGlobals = () => {
  syncLanguageToUrl();
  initScrollAnimations();

  initDefaultTopBarSwiper();
  initAuraTopBarSwiper();
  initAuraStickyHeader();
  initStickyHeaderNova();
  initMobileMenuOffcanvas();

  initArchiveMasonry();
  initHeroSlider();
  initHeroBento();
  initCtaSlider();
  initCtaImageParallax();
  initCategoriesSlider();
  initArchiveShowcaseVideos();
  initArticleWSlider();
  initServicesDeck();

  initNovaHomeCarousel();
  initApexAutoSlider();

  initVideoFacades();
  initGalleries();
  initAccordions();

  listen();
  hydrateComponents();

  console.log(
    `[Main JS] Main JS bundle initialized. Store status: ${!!store ? "Active" : "Missing"}`,
  );
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  setTimeout(initGlobals, 0);
}
